import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import EditContent from './EditContent';
import { LandPage, Container, Main } from './styles';
import CustomBodyContent from './CustomBodyContent';
import { Colors } from '~/config/Colors';
import { SLEditModal } from '~/pages/Sistema/componentes/SistemaList';
import { useSelector } from 'react-redux';

export default function AprovarOS() {
  const [data, setData] = useState([]);
  const [modulos, setModulos] = useState([]);
  const [anos, setAnos] = useState([]);
  const [anoAtivo, setAnoAtivo] = useState(new Date().getFullYear());
  const [clientes, setClientes] = useState([]);
  const [projetos, setProjetos] = useState([]);
  const [clienteFiltro, setClienteFiltro] = useState([]);
  const [projetoFiltro, setProjetoFiltro] = useState([]);
  const [mountedData, setMountedData] = useState();
  const [loadedData, setLoadedData] = useState(false);
  const { perfil } = useSelector(state => state.auth);

  useEffect(() => {
    setLoadedData(false);
  }, [anoAtivo]);

  useEffect(() => {
    setLoadedData(false);
  }, [perfil]);

  useEffect(() => {
    async function handleRequests() {
      api.get('/signed/geral/acessos/check').then(response => setModulos(response.data));
    }
    handleRequests();

    api
      .get('/signed/empresa/gestorprojeto/cliente/clientes', { params: { ativo: 1 } })
      .then(response => setClientes(response.data));

    api
      .get('/signed/empresa/gestorprojeto/projetos', {
        params: { ativo: 1, idCliente: clienteFiltro },
      })
      .then(response => setProjetos(response.data));

    setAnos([
      { id: new Date().getFullYear() - 2 },
      { id: new Date().getFullYear() - 1 },
      { id: new Date().getFullYear() },
    ]);
  }, []);

  return (
    <Main>
      <LandPage>
        <div className="content">
          <Container
            className="container-os"
            requests={{
              findAll: () =>
                api.get('/signed/empresa/suporte/aprovarordensservicos', {
                  params: { idCliente: clienteFiltro, idProjeto: projetoFiltro, ano: anoAtivo },
                }),
              findOne: thisData =>
                api.get('/signed/empresa/suporte/aprovarordemservico', {
                  params: { id: thisData.id },
                }),
              deleteOne: thisData =>
                api.delete('/signed/empresa/suporte/aprovarordemservico', {
                  data: { id: thisData.id },
                }),
            }}
            selects={[
              {
                list: clientes,
                value: 'id',
                label: 'nomeFantasia',
                outLabel: 'Todos os Clientes',
                filter: 'meses.list.idCliente',
                onChange: idCliente => {
                  setClienteFiltro(idCliente);
                },
              },
              {
                list: projetos,
                value: 'id',
                label: 'titulo',
                outLabel: 'Todos os Projetos',
                filter: 'meses.list.idProjeto',
                onChange: idProjeto => {
                  setProjetoFiltro(idProjeto);
                },
              },
            ]}
            setter={setData}
            setLoaded={setLoadedData}
            loaded={loadedData}
            informationPage={{
              title: 'Aprovação das Ordem de Serviço',
              subTitle: 'Aprove suas OS',
              icone: 'menu-aprovar-os',
              menu: true,
            }}
            tabFilter={{
              initial: { statusAprovacao: 'A' },
              tabAtivo: 3,
              list: [
                {
                  corDestaque: '#707070',
                  corFundo: Colors?.Color8,
                  title: 'Encerradas',
                  value: { statusAprovacao: 'E' },
                },
                {
                  corDestaque: '#dee54d',
                  corFundo: Colors?.Color8,
                  title: 'Aguard. Fechamento',
                  value: { statusAprovacao: 'T' },
                },
                {
                  corDestaque: '#76BD3E',
                  corFundo: Colors?.Color8,
                  title: 'Aguard. Aprov. Coord. Tecnico',
                  value: { statusAprovacao: 'C' },
                },
                {
                  corDestaque: Colors?.Color4,
                  corFundo: Colors?.Color8,
                  title: 'Aguard. Aprov. Coordenador',
                  value: { statusAprovacao: 'A' },
                },
              ],
            }}
          >
            <SLEditModal menu={true} title="Aprovar Ordem de Serviço" setter={setMountedData}>
              {mountedData && <EditContent {...{ mountedData }} />}
            </SLEditModal>

            <CustomBodyContent {...{ data, anos, anoAtivo, setAnoAtivo }} />
          </Container>
        </div>
      </LandPage>
    </Main>
  );
}
